// extracted by mini-css-extract-plugin
export default {"font_family":"TitreH1_font_family__qs2Do"};